import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getTaskTimeUnits } from '../common/taskProgress';

const PointsContext = createContext();

export const usePoints = () => useContext(PointsContext);

export const PointsProvider = ({ children, tasks = [] }) => {
  // Initialize points from localStorage or default to 0
  const [points, setPoints] = useState(() => {
    const savedPoints = localStorage.getItem('points');
    return savedPoints ? parseInt(savedPoints, 10) : 0;
  });
  const [pointsBreakdown, setPointsBreakdown] = useState({
    timeUnits: 0,
    tuPoints: 0,
    total: 0
  });
  const [minuteTick, setMinuteTick] = useState(() => Date.now());

  // Update localStorage when points change
  useEffect(() => {
    localStorage.setItem('points', points.toString());
  }, [points]);

  useEffect(() => {
    const interval = window.setInterval(() => setMinuteTick(Date.now()), 60 * 1000);
    return () => window.clearInterval(interval);
  }, []);

  const recalculatePoints = useCallback(() => {
    const now = new Date(minuteTick);
    let timeUnits = 0;

    tasks.forEach(task => {
      const tu = getTaskTimeUnits(task, now);
      timeUnits += tu?.tuScore || 0;
    });

    const total = Math.trunc(timeUnits / 10);
    setPoints(total);
    setPointsBreakdown({
      timeUnits,
      tuPoints: total,
      total
    });
  }, [tasks, minuteTick]);
  // Recalculate when tasks change (e.g., on initial load)
  useEffect(() => {
    recalculatePoints();
  }, [tasks, recalculatePoints]);

  return (
    <PointsContext.Provider value={{ points, pointsBreakdown }}>
      {children}
    </PointsContext.Provider>
  );
};
